<template>
  <div class="pt-2">
    <v-card flat>
      <v-form v-model="valid">
        <v-row class="my-1">
            <div class="form-item form-item-width-2 ">
                <label class="form-item-label mt-1 mr-1">门店：</label>
                <pd-shop-list class="form-item-value mr-1"
                    v-model="filter.shopId"
                    isSearch
                >
                </pd-shop-list>
            </div>
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch"
              >查询</v-btn
            >
            <v-btn :disabled="_hasButtonPermission('查询')" depressed @click="handleResetSearch">重置</v-btn>
            <!--
            <v-col cols="12" sm="1" style="text-align: right">
                <label>门店：</label>
            </v-col>
            <v-col cols="12" sm="2">
                <pd-shop-list
                        v-model="filter.shopId"
                ></pd-shop-list>
            </v-col>
          <v-col cols="12" sm="1"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch"
              >查询</v-btn
            >
            <v-btn :disabled="_hasButtonPermission('查询')" depressed @click="handleResetSearch">重置</v-btn>
          </v-col>
          -->
        </v-row>
      </v-form>
      <v-data-table
              :headers="headers"
              fixed-header
              :items="desserts"
              class="elevation-1 mt-2"
              :loading="loading"
              :server-items-length="totalDesserts"
              :page.sync="filter.pageNum"
              :items-per-page.sync="filter.pageSize"
              @update:page="handlePageChanged"
              @update:items-per-page="handlePageSizeChanged"
      >
        <template
                v-slot:body="{ items }"
        >
          <tbody>
          <tr
                  v-for="(item,index) in items"
                  :key="item.id"
          >
            <td class="border-right-a">{{ item.userId }}</td>
            <td class="border-right-a">{{ item.userName }}</td>
            <td class="border-right-a">{{ item.roleName}}</td>
            <td class="border-right-a">{{ item.mobile }}</td>
            <td>
              <v-btn  :disabled="(!_hasButtonPermission('编辑'))" icon class="mr-2" text @click="editItem(item)">
                编辑
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-dialog v-model="edit.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >修改角色</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-select label="选择角色" :items="roleList" v-model="edit.item.roleId" item-value="id" item-text="roleName"></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field label="手机号码" v-model="edit.item.mobile"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveItem"> 保存 </v-btn>
            <v-btn text @click="edit.dialog = false"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>



    </v-card>
  </div>
</template>

<script>
import { default as RoleApi } from "../../../../api/pd/maintenance/role/RoleApi.js";
import {default as PermissionApi} from "../../../../api/smp/auth/Permission.js"; 
export default {
  name: 'Pd-Manager-Role',
  props:['page'],
  data() {
    return {
        buttonPriviledgeList: {
        },
      roleList:[],
      tab: null,
      filter: {
        shopId:undefined,
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "人员id",
          value: "userId",
          sortable: false,
          width: 65,
          divider: true
        },
        {
          text: "人员名称",
          value: "userName",
          sortable: false,
          width: 100,
          divider: true
        },
        {
          text: "角色名称",
          align: "start",
          sortable: false,
          value: "roleName",
          width: 120,
          divider: true
        },
        {
          text: "手机号码",
          align: "start",
          sortable: false,
          value: "mobile",
          width: 80,
          divider: true
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      auditDialog: false,
      valid:false,
      edit:{
        item: {},
        dialog:false,
      }
    };
  },
  created() {
  },
  mounted() {
      this.getButtonPriviledge();
      this.getRoleList();

  },
  methods: {
    viewDetail(item) {
      this.$emit("viewDetailCallback", {
        formStatus: "detail",
        checkId: item.id,
      });
    },
    handleSearch() {
      this.filter.pageNum = 1;
      this.getDataFromApi();
    },
    handleResetSearch() {
      this.filter = {
        shopId: undefined,
        pageNum: 1,
        pageSize: 15,
      };
    },
    handlePageChanged(pageNum) {
      this.filter.pageNum = pageNum;
      this.getDataFromApi();
    },
    handlePageSizeChanged(pageSize) {
      if (pageSize == -1) {
        pageSize = 100;
      }
      this.filter.pageNum = 1;
      this.filter.pageSize = pageSize;
      this.getDataFromApi();
    },
    getQueryParams(query) {
      return query;
    },
    async getDataFromApi() {
      let me = this;
      me.loading = true;
      if(!me.filter.shopId) {
        this.$dialog.error({
          text: "请先选择门店",
          title: "操作失败",
        });
        return;
      }
      let queryUserResp = await RoleApi.list(me.filter);
      let data = queryUserResp.data;
      if (!data || !data.code || data.code != 200) {
        let msg = data.msg;
        msg = !msg || msg == "" ? "获取角色详情失败" : msg;
        me.loading = false;
        throw new Error(msg);
      }
      me.loading = false;
      me.desserts = data.data.rows;
      me.totalDesserts = data.data.total;
    },

    onInit: function () {
      return Promise.resolve()
    },

    async getRoleList() {
      let res = await RoleApi.getRoleList();
      if (res.data.code === 200) {
        this.roleList = res.data.data;
      } else {
        me.$dialog.error({
          text: res.data.msg,
          title: "操作失败",
        });
      }
    },

    async editItem(item) {
      this.edit.item = Object.assign({}, item);
      this.edit.dialog = true;
    },

    async saveItem() {
      let res = await RoleApi.addRole(this.edit.item);
      if (res.data.code === 200) {
        this.$dialog.info({
          text: res.data.msg,
          title: "操作成功",
        });
        this.edit.dialog = false;
        this.getDataFromApi();
      } else {
        this.$dialog.error({
          text: res.data.msg +':'+ res.data.msg_detail,
          title: "操作失败",
        });
      }
    },

      getButtonPriviledge(){
          console.log('this.page',this.page)
          let menuId = this.page.id
          let me = this
          PermissionApi.queryButtonPriviledge(menuId,null).then(resp=>{
              PermissionApi.handleResponse(resp, me, function (data){
                  me.buttonPriviledgeList = data.buttonPriviledges
                  console.log('buttonPriviledgeList',me.buttonPriviledgeList)
              })
          })
      },
      _hasButtonPermission(name){
          let buttonPriviledgeList = this.buttonPriviledgeList
          let hasButton =false
          for(let i=0;i<buttonPriviledgeList.length;i++){
              if(buttonPriviledgeList[i].name==name){
                  if(buttonPriviledgeList[i].hasPriviledge=='Y'){
                      return true
                  } else {
                      return false
                  }
              }
          }
          return false
      },
  },
};
</script>
<style scoped>
.padding-bottom {
  padding: 0 16px;
  /**padding-bottom: 12px;**/
}
.padding-top {
  padding-top: 30px;
}
.margin-right {
  margin-right: 12px;
}
</style>